import type { FunctionComponent } from 'react';
import { useContext } from 'react';

import { PlanComparisonEnterpriseHeaderCell } from './PlanComparisonHeaderCell/PlanComparisonEnterpriseHeaderCell';
import { PlanComparisonFreeHeaderCell } from './PlanComparisonHeaderCell/PlanComparisonFreeHeaderCell';
import { PlanComparisonPremiumHeaderCell } from './PlanComparisonHeaderCell/PlanComparisonPremiumHeaderCell';
import { PlanComparisonStandardHeaderCell } from './PlanComparisonHeaderCell/PlanComparisonStandardHeaderCell';
import { PlanComparisonContext } from './PlanComparisonContext';

import styles from './PlanComparisonHeader.less';

export interface OwnProps {
  isEligibleForTrial?: boolean;
  isMonthly: boolean;
  teamId: string;
  teamName: string;
  onShowFreeTrialModal: (planName: string) => void;
  isInPPCohort?: boolean;
}

export const PlanComparisonHeader: FunctionComponent<OwnProps> = ({
  isEligibleForTrial = false,
  isMonthly,
  teamId,
  teamName,
  onShowFreeTrialModal,
  isInPPCohort,
}) => {
  const { billingQuote } = useContext(PlanComparisonContext);

  return (
    <thead>
      <tr className={styles.headerRow}>
        <th className={styles.blankCell} />
        <PlanComparisonFreeHeaderCell isInPPCohort={isInPPCohort} />
        <PlanComparisonStandardHeaderCell
          teamId={teamId}
          teamName={teamName}
          isMonthly={isMonthly}
          prices={billingQuote?.standardPrices}
          isInPPCohort={isInPPCohort}
        />
        <PlanComparisonPremiumHeaderCell
          teamId={teamId}
          teamName={teamName}
          isMonthly={isMonthly}
          prices={billingQuote?.businessPrices}
          onShowFreeTrialModal={onShowFreeTrialModal}
          isEligibleForTrial={isEligibleForTrial}
          isInPPCohort={isInPPCohort}
        />
        <PlanComparisonEnterpriseHeaderCell
          teamId={teamId}
          isInPPCohort={isInPPCohort}
        />
      </tr>
    </thead>
  );
};
